import { render } from "./FileUploadsTable.vue?vue&type=template&id=107259c6"
import script from "./FileUploadsTable.vue?vue&type=script&lang=js"
export * from "./FileUploadsTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__